export const InitialValuesIngPriValidateDoc = {
	file: "",
}